import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { MyTimestampPipe } from '@shared/pipes';
// import { CampaignsService } from 'src/app/services/campaigns.service';
import { CampaignsService } from '@shared/services';
import type { TCampaign } from '@shared/models';

@Component({
    'selector': 'app-campaigns',
    'templateUrl': './campaigns.page.html',
    'styleUrls': ['./campaigns.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, MyTimestampPipe ]
})
export class CampaignsPage extends ViewBasePage implements OnInit, OnDestroy {
    public vm: any = {};
    private subscription: any = null;

    constructor( private campaignsService: CampaignsService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_CAMPAIGNS);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.vm.campaigns = [];
        const observable = this.campaignsService.getObservable();
        this.subscription = observable.subscribe(async (campaigns: TCampaign[]) => {
            this.vm.campaigns = this.campaignsService.sort(campaigns);
        });
        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-campaigns-tour');
    }

    public async onAddCampaignClick() {
        if (this.sessionService.getAccountProfile().featuresInfo.campaign) {
            this.router.navigateByUrl('/marketing/campaigns/campaign');
        } else {
            this.uxHelperService.showAlert('Sorry.', this.Constants.FEATURE_UPGRADE_TO_CUSTOMER_PACKAGE);
        }
    }
}
